import { useSelector } from "react-redux";

import {
    createLocationCodesCellValue,
    LocationGroupCell,
} from "app/pages/sales-intelligence/common-components/table-cells";
import type { LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search";
import { TabName } from "app/pages/sales-intelligence/sub-modules/account-overview/company/types/tabs";
import { COLUMN_TRAFFIC_COUNTRIES_NAME } from "app/pages/sales-intelligence/sub-modules/signals/constants";
import type {
    IUseTrackedSignalTooltipResponse } from "app/pages/sales-intelligence/sub-modules/signals/hooks/cells/useTrackedSignalTooltip";
import {
    useTrackedSignalTooltip,
} from "app/pages/sales-intelligence/sub-modules/signals/hooks/cells/useTrackedSignalTooltip";
import type TrafficCountrySignalRowDto from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficCountrySignalRowDto";
import TrafficSignalSubType from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficSignalSubType";
import { selectAppliedTrafficSignal } from "app/pages/sales-intelligence/sub-modules/signals/store/selectors";
import { getCompanyOverviewLink } from "app/pages/sales-intelligence/sub-modules/signals/utils/signalCompanyOverviewLink";

import { SignalTrafficCountriesTooltip } from "../SignalTrafficCountriesTooltip/SignalTrafficCountriesTooltip";

import { StyledCenteredBaseCell } from "./styles";

const DEFAULT_VALUE: TrafficCountrySignalRowDto[] = [];

interface ISignalTrafficCountriesCellContainerProps<V extends LeadsSearchRow> {
    value?: TrafficCountrySignalRowDto[];
    index: number;
    record: V;
}

export const SignalTrafficCountriesCellContainer = <V extends LeadsSearchRow>({
    value = DEFAULT_VALUE,
    index,
    record,
}: ISignalTrafficCountriesCellContainerProps<V>) => {
    const appliedTrafficSignal = useSelector(selectAppliedTrafficSignal);

    const filters = appliedTrafficSignal?.filters;

    const { redirectLink } = getCompanyOverviewLink({ activePageSection: TabName.signals, record });
    const { onTrackedTooltipClick }: IUseTrackedSignalTooltipResponse = useTrackedSignalTooltip({
        field: COLUMN_TRAFFIC_COUNTRIES_NAME,
        value: value.length,
    });

    const locationCodes = createLocationCodesCellValue(value.map((item: TrafficCountrySignalRowDto) => item.country));

    return (
        <SignalTrafficCountriesTooltip
            redirectLink={redirectLink}
            value={value}
            row={record}
            onViewAll={onTrackedTooltipClick}
            signalSubType={TrafficSignalSubType.NewMarkets}
            filters={{ metric: filters?.newMarkets?.metric ?? "" }}
        >
            <StyledCenteredBaseCell>
                <LocationGroupCell
                    locationCodes={locationCodes}
                    recordIndex={index}
                />
            </StyledCenteredBaseCell>
        </SignalTrafficCountriesTooltip>
    );
};
